import React from 'react';
import InspectButton from '../../InspectButton';
import ZoomOutButton from '../../ZoomOutButton';
import RiddleButton from '../../RiddleButton';
import PowerupsInfoButton from '../unlimited/PowerupsInfoButton';
import GenerationsSkipButton from './GenerationsSkipButton';
import './GenerationsGameControls.css';

const GenerationsGameControls = ({
  onSkip,
  onInspect,
  onZoomOut,
  onRiddleOpen,
  disableSkip,
  disableInspect,
  disableZoomOut,
  disableRiddle,
  isRiddleOpen,
  freeInspectsRemaining,
  freeZoomOutsRemaining,
  skipCostCoins,
  isSkipBuffering,
  skipLabelOverride,
}) => {
  return (
    <div className="game-controls generations-game-controls">
      <GenerationsSkipButton
        onSkip={onSkip}
        disabled={disableSkip}
        costCoins={skipCostCoins}
        isBuffering={isSkipBuffering}
        labelOverride={skipLabelOverride}
      />
      <InspectButton
        onInspect={onInspect}
        disabled={disableInspect}
        freeInspectsRemaining={freeInspectsRemaining}
      />
      <ZoomOutButton
        onZoomOut={onZoomOut}
        disabled={disableZoomOut}
        freeZoomOutsRemaining={freeZoomOutsRemaining}
      />
      <RiddleButton onOpen={onRiddleOpen} disabled={disableRiddle} isOpen={isRiddleOpen} />
      <PowerupsInfoButton />
    </div>
  );
};

export default GenerationsGameControls;

